import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';

class Section extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			cls : '',
			secname : '',
			sdate : '',
			edate : '',
			noofstud : '',
			_message : '',
			value : '',
			alertClass :'',
			posts : [],
			data : [],
			_redirect : false
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** reset the form **/
	onClick(e){
		
		document.getElementById("subform").reset();
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		if(this.state.secname){
			
			PostData('section/add',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Section Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("subform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 
          $("#showLoader").show();		
			PostData('section/deletesection',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Section Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Section',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
	componentWillMount(){
		
		this.getclass();
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('section/getsection').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to={'/academic/editsection/' + this.state.idd} />);

	}
	
	this.attype = [
		{value : '', name : 'Select'},
		{value : 'Daily', name : 'Daily'},
		{value : 'Subject Wise', name : 'Subject Wise'}
	];
	
	var items = this.state.posts;
	
    return (
		<div className="animated fadeIn">
		  <div className={this.state.alertClass}>
			{this.state._message}
		  </div>
			<Row>
			  <Col md="5">
				<Card>
				  <form action="" method="post" role="form" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Add Section</strong>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Class <span className="text-danger">*</span></Label>
							  <select name="cls" className="form-control" onChange={this.onChange} >
								<option value="">Select</option>
								{
									items.map(function (item) {
										return <option value={item.id }>{item.class}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Section <span className="text-danger">*</span></Label>
							  <Input type="text" name="secname" required onChange={this.onChange} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Start Date</Label>
							  <Input type="date" name="sdate" onChange={this.onChange} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">End Date</Label>
							  <Input type="date" name="edate" onChange={this.onChange} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Maximum Number of Students <span className="text-danger">*</span></Label>
							  <Input type="text" name="noofstud" onChange={this.onChange} />
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			  <Col md="7">
			   <Card>
				<CardBody>
				<Table responsive bordered>
					<thead>
						<tr>
							<th>S.No</th>
							<th width="100">Class</th>
							<th>Section</th>
							<th>Max.No.of Students</th>
							<th>Start Date</th>
							<th>End Date</th>
							<th width="100">Manage</th>
						</tr>
					</thead>
					<tbody>
						{this.state.data.map(item =>
						 
							<tr key = {item}>
								<td>{item.id}</td>
								<td>{item.classname}</td>
								<td>{item.section}</td>
								<td>{item.noofstudent}</td>
								<td>{item.startdate}</td>
								<td>{item.enddate}</td>
								<td>
									<button name="editacyear" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
									&nbsp;&nbsp;
									<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
								</td>
							</tr>
			  
						 )}
					</tbody>
				</Table>
				</CardBody>
			   </Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default Section;



// WEBPACK FOOTER //
// ./src/academic/Section/Section.js